export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16" data-testid="terms-page">
      <div className="overline mb-4">Terms</div>
      <h1 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight">Terms of Service</h1>
      <div className="mt-8 space-y-5 text-base leading-relaxed text-foreground/85">
        <p>Welcome to YUMO. By using this product you agree to the following common-sense terms.</p>
        <p>YUMO's recommendations are guidance from a food intelligence companion, not medical or dietary advice. Please honour your own allergies, restrictions, and judgment.</p>
        <p>Be kind in messages you send us. We're a small team building YUMO because we love food and we love people.</p>
        <p>This page will be expanded as YUMO evolves. Reach us at <a href="mailto:yumoaifoods@gmail.com" className="text-primary underline underline-offset-4">yumoaifoods@gmail.com</a> with any questions.</p>
      </div>
    </div>
  );
}
